var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.14286V17.9669L7.06476 15.7963L13.0648 18.7963L18 16.6812V3.85714L19.303 3.2987C19.5569 3.18992 19.8508 3.30749 19.9596 3.56131C19.9862 3.62355 20 3.69056 20 3.75827V18L13 21L7 18L0.69696 20.7013C0.44314 20.8101 0.14921 20.6925 0.0404301 20.4387C0.0137501 20.3765 0 20.3094 0 20.2417V6L2 5.14286ZM14.2426 10.2426L10 14.4853L5.75736 10.2426C3.41421 7.89949 3.41421 4.10051 5.75736 1.75736C8.1005 -0.585787 11.8995 -0.585787 14.2426 1.75736C16.5858 4.10051 16.5858 7.89949 14.2426 10.2426ZM10 11.6569L12.8284 8.82843C14.3905 7.26633 14.3905 4.73367 12.8284 3.17157C11.2663 1.60948 8.7337 1.60948 7.17157 3.17157C5.60948 4.73367 5.60948 7.26633 7.17157 8.82843L10 11.6569Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.dbde1d0dd4623d815253c2fbac969b40.svg";
export { ForwardRef as ReactComponent };